module.exports = __webpack_public_path__ + "static/media/exclamation.737f609d.svg";